import CustomerAutocomplete from '@/platform/common/components/CustomerAutocomplete/CustomerAutocomplete';
import { DashboardLayout } from '@/platform/layouts';
import {
    Button,
    Container,
    Dropdown,
    Form,
    FormGroup,
    Input,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Segment,
    Textarea,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';

const CreateOrUpdateView = () => {
    const { users, note, autocomplete_customer, labels } = usePage().props;
    const { data, setData, processing, post, patch, errors, reset } = useForm(
        note || { customer_id: autocomplete_customer?.id || null }
    );

    const handleSubmit = () => {
        if (data.id) {
            patch(`/notes/${data.id}`, {
                preserveScroll: true,
                preserveState: true,
                preserveUrl: true,
                replace: true,
                onSuccess: () => window.history.back(),
            });

            return;
        }

        post('/notes', {
            preserveScroll: true,
            preserveState: true,
            preserveUrl: true,
            replace: true,
            onSuccess: () => window.history.back(),
        });
    };

    const handleCustomerChange = value => {
        reset();

        setData('customer_id', value);
    };

    return (
        <Container fluid>
            <Segment>
                <Modal open={true} onClose={() => window.history.back()}>
                    <ModalHeader>
                        {data?.id
                            ? 'Notitie bewerken'
                            : 'Nieuwe notitie toevoegen'}
                    </ModalHeader>
                    <ModalContent>
                        <Form>
                            <FormGroup>
                                <CustomerAutocomplete
                                    label='Klant'
                                    onChange={value =>
                                        handleCustomerChange(value)
                                    }
                                />
                                <Dropdown
                                    label='Label'
                                    options={labels || []}
                                    value={data?.label || ''}
                                    onChange={value => setData('label', value)}
                                />
                                <Dropdown
                                    label='Terugkoppeling naar'
                                    multiple
                                    options={users || []}
                                    value={data?.feedback_users || []}
                                    onChange={value =>
                                        setData('feedback_users', value)
                                    }
                                />
                                <Input
                                    label='Onderwerp'
                                    value={data?.subject || ''}
                                    required
                                    onChange={event =>
                                        setData('subject', event.target.value)
                                    }
                                    error={errors?.subject || ''}
                                />
                                <Textarea
                                    label='Actie'
                                    rows={5}
                                    value={data?.action || ''}
                                    onChange={event =>
                                        setData('action', event.target.value)
                                    }
                                />
                                <Dropdown
                                    label='Status'
                                    options={[
                                        {
                                            id: 0,
                                            name: 'Open',
                                        },
                                        {
                                            id: 1,
                                            name: 'In behandeling',
                                        },
                                        {
                                            id: 3,
                                            name: 'Afgehandeld',
                                        },
                                    ]}
                                    value={data?.status || 0}
                                    onChange={value => setData('status', value)}
                                />
                            </FormGroup>
                        </Form>
                    </ModalContent>
                    <ModalActions>
                        <Button
                            onClick={() => window.history.back()}
                            type='button'
                        >
                            Annuleren
                        </Button>
                        <Button
                            variant='primary'
                            onClick={handleSubmit}
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </ModalActions>
                </Modal>
            </Segment>
        </Container>
    );
};

CreateOrUpdateView.layout = page => <DashboardLayout>{page}</DashboardLayout>;

export default CreateOrUpdateView;
